import React from 'react';

export const StorybookIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2329_1409)">
      <path
        d="M2.59388 18.3902L1.97563 1.91682C1.95521 1.37276 2.37237 0.911686 2.91575 0.877725L16.9275 0.00198812C17.4806 -0.0325801 17.957 0.387766 17.9916 0.940857C17.9929 0.961695 17.9935 0.982569 17.9935 1.00345V18.9541C17.9935 19.5083 17.5443 19.9576 16.9901 19.9576C16.9751 19.9576 16.9601 19.9572 16.9451 19.9566L3.55156 19.355C3.02994 19.3316 2.61346 18.912 2.59388 18.3902Z"
        fill="#FF4785"
      />
      <mask
        id="mask0_2329_1409"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="17"
        height="20"
      >
        <path
          d="M2.59388 18.3902L1.97563 1.91682C1.95521 1.37276 2.37237 0.911686 2.91575 0.877725L16.9275 0.00198812C17.4806 -0.0325801 17.957 0.387766 17.9916 0.940857C17.9929 0.961695 17.9935 0.982569 17.9935 1.00345V18.9541C17.9935 19.5083 17.5443 19.9576 16.9901 19.9576C16.9751 19.9576 16.9601 19.9572 16.9451 19.9566L3.55156 19.355C3.02994 19.3316 2.61346 18.912 2.59388 18.3902Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2329_1409)">
        <path
          d="M13.8035 2.4531L13.8992 0.15119L15.8234 0L15.9063 2.37388C15.9092 2.4565 15.8446 2.52581 15.762 2.5287C15.7266 2.52993 15.6919 2.51859 15.6641 2.49669L14.9221 1.91213L14.0435 2.57857C13.9776 2.62853 13.8837 2.61564 13.8338 2.54978C13.8127 2.52206 13.802 2.48787 13.8035 2.4531ZM11.3426 7.52228C11.3426 7.91266 13.9721 7.72556 14.3251 7.45134C14.3251 4.7929 12.8987 3.39593 10.2866 3.39593C7.67452 3.39593 6.21101 4.81464 6.21101 6.94269C6.21101 10.6491 11.2129 10.72 11.2129 12.7416C11.2129 13.3091 10.935 13.6461 10.3237 13.6461C9.52706 13.6461 9.21213 13.2392 9.24918 11.856C9.24918 11.5559 6.21101 11.4624 6.11838 11.856C5.88252 15.2081 7.97093 16.1749 10.3607 16.1749C12.6764 16.1749 14.4919 14.9406 14.4919 12.7062C14.4919 8.73381 9.41591 8.84021 9.41591 6.87176C9.41591 6.07374 10.0087 5.96733 10.3607 5.96733C10.7312 5.96733 11.3981 6.03264 11.3426 7.52228Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2329_1409">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
